import React from 'react'

import People from 'client/icons/People'
import PaxesText from 'src/comps/Atom/PaxesText'
import { SearchMode } from 'src/types/search'

import { PaxesSelectorInput, PillFullMode } from './styles'

function PaxesPill({
  paxes,
  mode = SearchMode.Full,
}: {
  paxes: {
    rooms: number
    adults: number
    children: number
  }
  mode?: SearchMode
}) {
  if (mode === SearchMode.Borderless) {
    return <PillFullMode leftIcon={<People />} label={<PaxesText paxes={paxes} mode={mode} />} />
  }

  if (mode === SearchMode.Full) {
    return (
      <PaxesSelectorInput>
        <PillFullMode leftIcon={<People />} label={<PaxesText paxes={paxes} mode={mode} />} />
      </PaxesSelectorInput>
    )
  }
  return null
}

export default PaxesPill
